import { CollectionName } from "@super-real/types";
import { doc } from "firebase/firestore";
import { db } from "../consts/FIREBASE";

export function getDocRef(collectionName: CollectionName, docId: string) {
  return doc(db, collectionName, docId);
}
